import { supabase } from '@/lib/supabase';
import * as Sentry from '@sentry/react';

type CheckoutResult = { success: boolean; error: string; url?: string };

export const createCheckoutSessionService = async (
    plan = 'annual',
    organizationData: any,
): Promise<CheckoutResult> => {
    try {
        const {
            data: { session },
        } = await supabase.auth.getSession();

        const res = await fetch(
            `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/create-subscription`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${session?.access_token || import.meta.env.VITE_SUPABASE_ANON_KEY
                        }`,
                    apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
                },
                body: JSON.stringify({
                    shop_id: organizationData.id,
                    email: organizationData.email,
                    lookup_key: plan,
                    vat_number: organizationData.vat_id,
                }),
            },
        );

        if (!res.ok) {
            throw new Error('Errore nella creazione della sessione di pagamento');
        }

        const data = await res.json();

        if (!data.url) {
            throw new Error('URL di checkout mancante');
        }

        return { success: true, error: '', url: data.url };
    } catch (error: any) {
        Sentry.captureException(error, {
            tags: { feature: 'billing', action: 'create_checkout_session' },
            extra: { plan, organizationId: organizationData?.id }
        });
        console.error(
            'Errore nella creazione della sessione di pagamento:',
            error,
        );
        return { success: false, error: error?.message ?? 'Errore pagamento' };
    }
};